// Regras puras da importação de produtos via planilha (importProducts.jsx).
// Mantido fora do componente para ser testável sem React/DOM.

const _isEmpty = (value) =>
  value === null || value === undefined || String(value).trim() === "";

// Aceita "199,90", "1.234,56", "199.90", 199.9 e devolve sempre string com ponto
// decimal (ou null quando a célula veio vazia).
export const normalizePrice = (value) => {
  if (_isEmpty(value)) {
    return null;
  }
  if (typeof value === "number") {
    return String(value);
  }

  const clean = String(value).trim().replace(/[^\d.,-]/g, "");

  if (clean.includes(",")) {
    // vírgula é o separador decimal: os pontos são milhar
    return clean.replace(/\./g, "").replace(",", ".");
  }
  return clean;
};

const _text = (value) =>
  _isEmpty(value) ? null : String(value).trim().toUpperCase();

const _list = (value, fallback) =>
  _isEmpty(value) ? [fallback] : String(value).split(",");

// Converte as linhas lidas da planilha no payload de /products/import.
// Linhas sem os campos obrigatórios (produto, referência e algum preço) são
// separadas em `invalidRows` em vez de derrubar a importação.
export const buildImportPayload = (rows, userId) => {
  const products = [];
  const invalidRows = [];

  Array.from(rows || []).forEach((item, index) => {
    const title = _text(item.title);
    const ref = _isEmpty(item.ref) ? null : String(item.ref).trim();
    const discount = normalizePrice(item.discount);
    const price = normalizePrice(item.price) ?? discount;

    if (!title || !ref || price === null) {
      // +2: a planilha tem cabeçalho na linha 1
      invalidRows.push({ line: index + 2, title, ref });
      return;
    }

    products.push({
      title,
      ref,
      shortDesc: item.shortDesc ?? null,
      desc: item.desc ?? null,
      price,
      discount: discount ?? price,
      colors: _list(item.colors, "Não informada"),
      sizes: _list(item.sizes, "Não informada"),
      lastUserUpdate: userId,
      category: item.category ?? null,
      subcategory: item.subCategory ?? null,
    });
  });

  return { products, invalidRows };
};
